
import React, { useEffect, useState, forwardRef, useRef } from "react";
import ReactToPrint, { PrintContextConsumer, useReactToPrint } from "react-to-print";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import { Link, useNavigate } from "react-router-dom";
import {
    Box, Button, Grid, Dialog, DialogTitle, TextField, DialogActions,
    TablePagination, Typography, InputAdornment, DialogContent, IconButton, Tooltip, Card, CardContent, Container, Popover, Divider, Hidden, Snackbar
} from '@mui/material';
import { Icon } from '@iconify/react';
import EditIcon from '@mui/icons-material/Edit';
import { SearchOutlined } from '@mui/icons-material';

import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import AddBoxIcon from '@mui/icons-material/AddBox';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import Breadcrumb from "../../reusableComponent/Breadcrumb";
import { StyledTableRow, StyledTableCell } from '../../reusableComponent/StyledTable'
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useDispatch, useSelector } from "react-redux";
import { editDeletePurchaseInvoice, editDeleteSaleInvoice, getDocNoFormateAvailable, getInvoicePrintTitleList, getInvoiceSettingList, getPrintSetupList, getPurchaseInvoiceList, getSaleInvoiceList, getTermsConditionsList } from "../../../actions/actions";
import DeleteSnackbar from "../../reusableComponent/DeleteSnackbar";
import { BootstrapDialog, BootstrapDialogTitle } from "../../reusableComponent/BootstrapDialog";
import AddIcon from '@mui/icons-material/Add';
import { dateConversion, dateConversionOnEntryPage } from "../../reusableComponent/dateConversionOnEntryPage";
import styles from '.././../../styles.module.css';
import ExcelDownload from "../../reusableComponent/ExcelDownload";
import upload_excel from '../../../images/upload_excel.png'
import SalesInvoiceDetails from "./SalesInvoiceDetails";
import SalesInvoiceAdd from "./SalesInvoiceAdd";
import SalesInvoicePrint from "./SalesInvoicePrint";
import { BackBtn } from "../../reusableComponent/BackBtn";
import SalesHome from "../salesHome/SalesHome";



const ComponentToPrintRow = forwardRef((props, ref) => {
    const { value, invoicePrintTitleDetails, printSetupDetails, invoiceSettingList } = props;
    return (
        <div className="print-source" ref={ref}>
            <SalesInvoicePrint pEntryPrint={value} invoicePrintTitleDetails={invoicePrintTitleDetails} printSetupDetails={printSetupDetails} invoiceSettingList={invoiceSettingList} />
        </div>
    );
});

const ComponentToPrintPEntryWrapper = ({ pEntryPrint, invoicePrintTitleDetails, printSetupDetails, invoiceSettingList }) => {
    const ref = useRef();

    return (
        <div style={{ display: "flex" }}>
            <ReactToPrint
                trigger={() => <span style={{ display: 'flex', justifyContent: 'center' }}>  <Icon icon="flat-color-icons:print" width="20" height="20" />  <span style={{ marginLeft: '22px' }}>  Print Record </span> </span>}
                content={() => ref.current}
            />
            <div style={{ display: 'none' }}>
                <ComponentToPrintRow ref={ref} value={pEntryPrint} invoicePrintTitleDetails={invoicePrintTitleDetails} printSetupDetails={printSetupDetails} invoiceSettingList={invoiceSettingList} />
            </div>
        </div>
    );
};


function SalesInvoiceList(props) {
    const dispatch = useDispatch();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    let ref = useRef();
    const tableRef = useRef(null);
    // const [open, setOpen] = React.useState(false);
    const [openPopup, setOpenPopup] = React.useState(false);
    const [info, setInfo] = useState({});
    const [printSetupPopup, setPrintSetupPopup] = useState([])
    const [invoicePrintTitlePopup, setInvoicePrintTitlePopup] = useState([])

    const [successMessage, setSuccessMessage] = useState(null);
    const [openOption, setOpenOption] = useState('');

    const handleClickOpenPopup = (info) => {
        setInfo(info);
        setOpenPopup(true);
        setOpenOption(info.si_id ? 'SaleUpdate' : 'SaleAdd')
    };
    const [rowsPerPage, setRowsPerPage] = React.useState(10)
    const [page, setPage] = React.useState(0)

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }

    const [q, setQ] = useState("");
    const [searchParam] = useState(["CNS_Name", "CNS_Type", "basicTotal", "city", "contactPerson", "creditLimit", "creditPeriod", "emailId", "gstTotal", "invoiceDate", "invoiceNo", "challanNo", "challanDate", "mobileNo", "accountManagerName", "orderRefDate", "orderRefNo", "panNo", "eWayBillNo", "modeOfTransport", "pinCode", "state", "taxType", "total", "vehicleNo", "paymentTerms", "contactPerson", "pendingAmount", "paymentStatus", "billAddress", "remark"]);

    const [isDelete, setIsDelete] = useState(false);
    const [deleteInfo, setDeleteInfo] = useState();

    const rows = useSelector(state => state.saleInvoice.saleInvoice)

    const invoicePrintTitleDetails = useSelector(state => state.invoicePrintTitle.invoicePrintTitle)
    const printSetupDetails = useSelector(state => state.printSetup.printSetup)
    const invoiceSettingList = useSelector(state => state.invoiceSetting.invoiceSetting)
    const docNoFormateAvailable = useSelector(state => state.docNoFormate.docNoFormateAvailable)
    const termsList = useSelector(state => state.termsConditions.termsConditions)


    const fetchData = () => {
        dispatch(getSaleInvoiceList({ companyId: userInfo.companyId }))
        dispatch(getInvoicePrintTitleList({ companyId: userInfo.companyId }))
        dispatch(getPrintSetupList({ companyId: userInfo.companyId }))
        dispatch(getInvoiceSettingList({ companyId: userInfo.companyId }))
        dispatch(getDocNoFormateAvailable({ companyId: userInfo.companyId, documentTypeName: 'Sales Invoice' }))
        dispatch(getTermsConditionsList({ companyId: userInfo.companyId, terms: 'Sales Invoice' }));
    };

    useEffect(() => {
        fetchData()
    }, []);

    useEffect(() => {
    }, [invoiceSettingList])

    useEffect(() => {
    }, [termsList])

    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.saleInvoice.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
        }
    }, [responseMessage, dispatch, invoiceSettingList]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                setSuccessMessage(responseMessage);
                setShouldShowMsg(false);
                dispatch({ type: 'RESET_MESSAGE' }); // Dispatch an action to reset the message
                fetchData();
                setOpenPopup(false);
            }
        }
    }, [shouldShowMsg, responseMessage, fetchData]);


    const handleDelete = (functions) => {
        setIsDelete(true);
        setDeleteInfo(functions);

        // setAnchorEl(null);
    }

    const deleteRecord = (si_id) => {
        dispatch(editDeleteSaleInvoice({ id: si_id, modifiedBy: userInfo.userId, modifiedAt: dateConversionOnEntryPage(new Date()), changedUpdatedValue: 'delete' }));
        setIsDelete(false);
        fetchData()
    }

    const handleClose = (event, reason) => {
        setIsDelete(false)
        setDeleteInfo(null);
        // setAnchorEl(null);
        setOpenPopup(false);
    };
    const handleDetails = (info, invoiceTitle, printSetUP) => {
        setInfo(info);
        setPrintSetupPopup(printSetUP);
        setInvoicePrintTitlePopup(invoiceTitle)
        setOpenPopup(true);
        setOpenOption('SaleDetails')
    }
    function search() {
        return rows && rows.filter((item) => {
            return searchParam.some((newItem) => {
                return (
                    item[newItem] && item[newItem].toString().toLowerCase().indexOf(q.toLowerCase()) > -1
                );
            });
        });
    }

    const [sortBy, setSortBy] = useState(null);
    const handleSort = (property) => {
        const isAsc = sortBy === property && sortBy !== null;
        setSortBy(isAsc ? property + '_desc' : property);
        rows.sort((a, b) => {
            if (typeof a[property] === 'number' && typeof b[property] === 'number') {
                return isAsc ? a[property] - b[property] : b[property] - a[property];
            } else {
                return isAsc ? a[property].localeCompare(b[property]) : b[property].localeCompare(a[property]);
            }
        });
    };

    const fields = ['si_id', "invoiceNo", "invoiceDate", "CNS_Name", "challanNo", "challanDate", "accountManagerName", "orderRefNo", "orderRefDate", "eWayBillNo", "modeOfTransport", "vehicleNo", "paymentTerms", "contactPerson", "basicTotal", "gst", "gstTotal", "total", "cgstTotal", "sgstTotal", "igstTotal", "remark", "billAddress", "shipAddress"];
    const labels = ['Id', "Invoice No", "invoice Date", "customer Name", "Challan No", "Challan Date", "Account Manager Name", "Order Ref No", "order Ref Date", "E-Way Bill No", "Mode of Transport", "Vehicle No", "Payment Terms", "Contact Person", "Basic Total", "GST", "GST Total", "Total", "CGST Total", "SGST Total", "IGST Total", "Remark", "Billing Address", "Shipping Address"];
    const handleCloseSuccessMsg = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSuccessMessage(false)
    };


    const actionMsg = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleCloseSuccessMsg}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );
    const navigate = useNavigate()
    const backBtn = props.currentTab
    const navigateToAddEdit = (row) => {
        const state = {
            row,
            invoiceSettingList,
            docNoFormateAvailable,
            backBtn,
            termsList,
        };
        navigate('/sales/add-sales-invoice', { state });
    };
    // const [anchorEl, setAnchorEl] = React.useState(null);

    // const handleClick = (event) => {
    //     setAnchorEl(event.currentTarget);
    // };
    // const open = Boolean(anchorEl);
    // const id = open ? 'simple-popover' : undefined;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClosePopOver = () => {
        setAnchorEl(null);  // Close the popover by setting anchorEl to null
    };
    return (
        <>
            <Breadcrumb
                routeSegments={[
                    { name: 'Sales', path: '/sales/' },
                    { name: 'Sales Invoice List' },
                ]}
            />
            <SalesHome />
            <Paper className={`${styles.list_container}`}>
                <Box sx={{ display: 'flex' }}>
                    <Grid container spacing={0.2} sx={{ pt: 0.5, pb: 0.5 }}>
                        <Grid item md={7} xs={0}>
                            {/* <Typography className={`${styles.page_title}`}> Sales Invoice List</Typography> */}
                        </Grid>
                        <Grid item md={5} xs={12} style={{ display: 'flex', }}>
                            <Box className={`${styles.excel_box}`}>
                                <ExcelDownload
                                    data={rows}
                                    fields={fields}
                                    labels={labels}
                                    filename="Sales Invoice List"
                                />
                            </Box>
                            <TextField
                                fullWidth
                                sx={{
                                    "& .MuiInputBase-root": {
                                        height: 25,
                                        fontSize: '11px',
                                        paddingLeft: '1px',
                                    }
                                }}
                                type="search"
                                name="search"
                                placeholder="Search"
                                value={q}
                                size="small"
                                onChange={(e) => setQ(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start" >
                                            <IconButton sx={{ padding: '4px' }}>
                                                <SearchOutlined className={`${styles.search_icon}`} />
                                                <Divider orientation="vertical" flexItem />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />
                            <Button variant="contained" className={`${styles.add_btn}`} onClick={() => navigateToAddEdit()}>
                                <AddIcon viewBox="3 3 18 18" className={`${styles.add_icon}`} /> Create New
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
                <TableContainer component={Paper} style={{ overflowY: 'auto', maxHeight: 350 }}>
                    <Table sx={{ minWidth: 650 }} size="small" stickyHeader ref={tableRef}>
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell align="center" className={`${styles.table_head}`} >Action</StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('invoiceNo')}>Invoice No <span className={`${styles.sort_icon}`}> {sortBy === 'invoiceNo' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('invoiceDate')}>Invoice Date <span className={`${styles.sort_icon}`}> {sortBy === 'invoiceDate' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('CNS_Name')}>Billing Party <span className={`${styles.sort_icon}`}> {sortBy === 'CNS_Name' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="left" className={`${styles.table_head}`} onClick={() => handleSort('challanNo')}>PO. No <span className={`${styles.sort_icon}`}> {sortBy === 'challanNo' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="right" className={`${styles.table_head}`} onClick={() => handleSort('paymentTerms')}><span className={`${styles.sort_icon}`}> {sortBy === 'paymentTerms' ? '▲' : '▼'} </span> Payment Terms</StyledTableCell>
                                <StyledTableCell align="right" className={`${styles.table_head}`} onClick={() => handleSort('basicTotal')}> <span className={`${styles.sort_icon}`}> {sortBy === 'basicTotal' ? '▲' : '▼'} </span>Basic Amount</StyledTableCell>
                                {invoiceSettingList[0] && invoiceSettingList[0].showDiscountPer_header === 'true' &&
                                    <>
                                        <StyledTableCell align="right" className={`${styles.table_head}`} onClick={() => handleSort('totalDiscountPer')}> <span className={`${styles.sort_icon}`}> {sortBy === 'totalDiscountPer' ? '▲' : '▼'} </span>Discount %</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.table_head}`} onClick={() => handleSort('totalDiscountAmt')}> <span className={`${styles.sort_icon}`}> {sortBy === 'totalDiscountAmt' ? '▲' : '▼'} </span>Discount Amount</StyledTableCell>
                                    </>
                                }

                                {invoiceSettingList[0] && invoiceSettingList[0].showPackingForwarding === 'true' &&
                                    <StyledTableCell align="right" className={`${styles.table_head}`} onClick={() => handleSort('packing_forwarding')}> <span className={`${styles.sort_icon}`}> {sortBy === 'packing_forwarding' ? '▲' : '▼'} </span>Packing & Forwarding</StyledTableCell>
                                }
                                {invoiceSettingList[0] && invoiceSettingList[0].showFreightCharges === 'true' &&
                                    <StyledTableCell align="right" className={`${styles.table_head}`} onClick={() => handleSort('freight_charges')}> <span className={`${styles.sort_icon}`}> {sortBy === 'freight_charges' ? '▲' : '▼'} </span>Freight Charges</StyledTableCell>
                                }
                                {invoiceSettingList[0] && invoiceSettingList[0].showTempoCharges === 'true' &&
                                    <StyledTableCell align="right" className={`${styles.table_head}`} onClick={() => handleSort('tempo_charges')}> <span className={`${styles.sort_icon}`}> {sortBy === 'tempo_charges' ? '▲' : '▼'} </span>Tempo Charges</StyledTableCell>
                                }
                                {invoiceSettingList[0] && invoiceSettingList[0].showOtherCharges === 'true' &&
                                    <StyledTableCell align="right" className={`${styles.table_head}`} onClick={() => handleSort('other_charges')}> <span className={`${styles.sort_icon}`}> {sortBy === 'other_charges' ? '▲' : '▼'} </span>Other Charges</StyledTableCell>
                                }
                                <StyledTableCell align="right" className={`${styles.table_head}`} onClick={() => handleSort('assessableAmt')}> <span className={`${styles.sort_icon}`}> {sortBy === 'assessableAmt' ? '▲' : '▼'} </span>Assessable Amount</StyledTableCell>
                                {invoiceSettingList[0] && invoiceSettingList[0].showGstPer_header === 'true' &&
                                    <>
                                        <StyledTableCell align="right" className={`${styles.table_head}`} onClick={() => handleSort('gst')}> <span className={`${styles.sort_icon}`}> {sortBy === 'gst' ? '▲' : '▼'} </span>GST %</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.table_head}`} onClick={() => handleSort('gstTotal')}> <span className={`${styles.sort_icon}`}> {sortBy === 'gstTotal' ? '▲' : '▼'} </span>GST Amt</StyledTableCell>
                                    </>
                                }
                                <StyledTableCell align="right" className={`${styles.table_head}`} onClick={() => handleSort('total')}> <span className={`${styles.sort_icon}`}> {sortBy === 'total' ? '▲' : '▼'} </span>Total Amount </StyledTableCell>

                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {rows && search(rows)
                                .slice(
                                    page * rowsPerPage,
                                    page * rowsPerPage + rowsPerPage
                                )
                                .map((row, index) => (
                                    <StyledTableRow
                                        key={row.si_id}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                        <StyledTableCell align="center" className='listTableBody'>
                                            <PopupState variant="popover" popupId="demo-popup-popover">
                                                {(popupState) => (
                                                    <div>
                                                        <MoreHorizIcon
                                                            id={styles.actionBtn}
                                                            alt="translator"
                                                            variant="contained"
                                                            // onClick={handleClick}
                                                            {...bindTrigger(popupState)}
                                                        />
                                                        <Popover

                                                            {...bindPopover(popupState)}
                                                            anchorOrigin={{
                                                                vertical: "right",
                                                                horizontal: "center"
                                                            }}
                                                            transformOrigin={{
                                                                vertical: "right",
                                                                horizontal: "center"
                                                            }}
                                                        >
                                                            <Container className={`${styles.tbl_action}`}>
                                                                <>
                                                                    <Button className={`${styles.list_tbl_action_btn}`} onClick={() => navigateToAddEdit(row)}>
                                                                        <EditIcon style={{ float: 'left', fontSize: '20px', cursor: 'pointer' }} />
                                                                        <span style={{ marginRight: '13px' }}> Edit Record</span>
                                                                    </Button>

                                                                    <Button onClick={popupState.close} className={`${styles.list_tbl_action_btn}`}>
                                                                        <ComponentToPrintPEntryWrapper key={index} pEntryPrint={row} invoicePrintTitleDetails={invoicePrintTitleDetails} printSetupDetails={printSetupDetails} invoiceSettingList={invoiceSettingList} />
                                                                    </Button>
                                                                    <Button className={`${styles.list_tbl_action_btn}`} onClick={() => { handleDelete(row); popupState.close() }} >
                                                                        <Icon icon="ic:baseline-delete-forever" color="#c70000" width="20" height="20" /> Delete Record
                                                                    </Button>
                                                                </>
                                                            </Container>
                                                        </Popover>
                                                    </div>
                                                )}
                                            </PopupState>
                                        </StyledTableCell>

                                        <StyledTableCell align="left" className={`${styles.list_table_body}`} onClick={() => handleDetails(row, invoicePrintTitleDetails, printSetupDetails)}>
                                            <span style={{ cursor: 'pointer', color: 'blue' }} >{row.invoiceNo} </span>
                                        </StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{dateConversion(row.invoiceDate)}</StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.customerName == null ? '-' : row.CNS_Name}</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.list_table_body}`}> {row.orderRefNo} </StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.list_table_body}`}>{row.paymentTerms}</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.list_table_body}`}>{parseFloat(row.basicTotal).toFixed(2)}</StyledTableCell>
                                        {invoiceSettingList[0] && invoiceSettingList[0].showDiscountPer_header === 'true' &&
                                            <>
                                                <StyledTableCell align="right" className={`${styles.list_table_body}`}>{parseFloat(row.totalDiscountPer)}</StyledTableCell>
                                                <StyledTableCell align="right" className={`${styles.list_table_body}`}>{parseFloat(row.totalDiscountAmt).toFixed(2)}</StyledTableCell>
                                            </>
                                        }
                                        {invoiceSettingList[0] && invoiceSettingList[0].showPackingForwarding === 'true' &&
                                            <StyledTableCell align="right" className={`${styles.list_table_body}`}>{parseFloat(row.packing_forwarding).toFixed(2)}</StyledTableCell>
                                        }
                                        {invoiceSettingList[0] && invoiceSettingList[0].showFreightCharges === 'true' &&
                                            <StyledTableCell align="right" className={`${styles.list_table_body}`}>{parseFloat(row.freight_charges).toFixed(2)}</StyledTableCell>
                                        }
                                        {invoiceSettingList[0] && invoiceSettingList[0].showTempoCharges === 'true' &&
                                            <StyledTableCell align="right" className={`${styles.list_table_body}`}>{parseFloat(row.tempo_charges).toFixed(2)}</StyledTableCell>
                                        }
                                        {invoiceSettingList[0] && invoiceSettingList[0].showOtherCharges === 'true' &&
                                            <StyledTableCell align="right" className={`${styles.list_table_body}`}>{parseFloat(row.other_charges).toFixed(2)}</StyledTableCell>
                                        }
                                        <StyledTableCell align="right" className={`${styles.list_table_body}`}>{parseFloat(row.assessableAmt).toFixed(2)}</StyledTableCell>
                                        {invoiceSettingList[0] && invoiceSettingList[0].showGstPer_header === 'true' &&
                                            <>
                                                <StyledTableCell align="right" className={`${styles.list_table_body}`}>{parseFloat(row.gst)}</StyledTableCell>
                                                <StyledTableCell align="right" className={`${styles.list_table_body}`}>{parseFloat(row.gstTotal).toFixed(2)}</StyledTableCell>
                                            </>
                                        }
                                        <StyledTableCell align="right" className={`${styles.list_table_body}`}>
                                            {invoiceSettingList[0] && invoiceSettingList[0].showRoundOff === 'true' ?
                                                parseFloat(Math.round(row.total)).toFixed(2)
                                                :
                                                parseFloat(row.total).toFixed(2)
                                            }
                                        </StyledTableCell>

                                    </StyledTableRow>
                                ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    sx={{ px: 2 }}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    backIconButtonProps={{
                        'aria-label': 'Previous Page',
                    }}
                    nextIconButtonProps={{
                        'aria-label': 'Next Page',
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
            <Dialog open={isDelete}
                PaperProps={{
                    sx: {
                        minWidth: "35%",
                        minHeight: "22%",
                        borderRadius: '8px'
                    }
                }}>
                <DialogTitle className={`${styles.dilog_delete_title}`}>
                    Confirm Delete The Record?
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            right: 0,
                            top: 0,
                            float: 'right'
                        }} >
                        <CloseIcon style={{ height: '18px', color: '#000000' }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent className={`${styles.dilog_delete_content}`}>
                    The BillCube will remove this record # {deleteInfo && deleteInfo.invoiceNo}
                </DialogContent>
                <DialogActions sx={{ padding: '10px', }}>
                    <Button onClick={handleClose} className={`${styles.dilog_delete_no_btn}`} variant='outlined'>
                        No
                    </Button>
                    <Button onClick={() => deleteRecord(deleteInfo.si_id)} className={`${styles.dilog_delete_yes_btn}`} variant='outlined'>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            <BootstrapDialog
                PaperProps={{
                    sx: {
                        maxWidth: "85%",
                        height: "95%",
                        maxHeight: '98%',
                        minWidth: '80%',
                    }
                }}
                onClose={handleClose}
                open={openPopup}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose} >
                    {openOption === 'SaleAdd' && 'Create Sales Invoice'}
                    {openOption === 'SaleUpdate' && 'Update Sales Invoice'}
                    {openOption === 'SaleDetails' && 'Sales Invoice Details'}
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    {(openOption === 'SaleUpdate' || openOption === 'SaleAdd') &&
                        <SalesInvoiceAdd handleCloseDialog={handleClose} details={info} invoiceSettingList={invoiceSettingList} docNoFormateAvailable={docNoFormateAvailable} onAPISubmt={fetchData} />
                    }
                    {openOption === 'SaleDetails' &&
                        <SalesInvoiceDetails details={info} invoicePrintTitleDetails={invoicePrintTitlePopup} printSetupDetails={printSetupPopup} invoiceSettingList={invoiceSettingList} termsList={termsList} />
                    }
                </DialogContent>
            </BootstrapDialog>

            {successMessage &&
                <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    open={successMessage ? true : false}
                    autoHideDuration={2000}
                    onClose={handleCloseSuccessMsg}
                    message={successMessage}
                    action={actionMsg}
                />
            }
        </>
    )
}



export default SalesInvoiceList